export default __webpack_public_path__ + "static/media/schedule-24px.2e728acd.svg";